import { useEffect, useRef, useState } from 'react';

const useScrollBottom = () => {
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const scrollableContainerRef = useRef(null) as any;

  const onScroll = () => {
    if (scrollableContainerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollableContainerRef.current;
      setIsScrolledToBottom(scrollTop >= scrollHeight - clientHeight);
    }
  };

  useEffect(() => {
    onScroll();
    scrollableContainerRef?.current?.addEventListener('scroll', onScroll);
    return () => {
      scrollableContainerRef?.current?.removeEventListener('scroll', onScroll);
    };
  }, [scrollableContainerRef?.current]);

  return [isScrolledToBottom, scrollableContainerRef];
};

export default useScrollBottom;
